import { useMutation, useQuery } from "@tanstack/react-query";
import { fileAttachmentApiService } from "./file.api";
// ------------------------------------------------------------------
// Files Select All
// ------------------------------------------------------------------

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}
    
export const useFileService = (
  searchText?: string | null,
  folderid?: number | null,
  pageNumber: number = 1,
  pageSize: number = 10,
  isParentSelectAll: boolean = false,
) => {
  const FilesSelectAllQuery = useQuery<ApiResponse>({
    queryKey: ["file-selectAll", folderid, searchText, pageNumber, pageSize],
    queryFn: () =>
      fileAttachmentApiService.getFilesSelectAllData(
        folderid!,
        searchText,
        pageNumber,
        pageSize,
      ),
    enabled: !!folderid && !!pageNumber && !!pageSize && !isParentSelectAll,
  });

  const ParentFilesSelectAllQuery = useQuery({
    queryKey: [
      "folder-parentSelectAll",
      folderid,
      searchText,
      pageNumber,
      pageSize,
    ],
    queryFn: () =>
      fileAttachmentApiService.getParentFilesSelectAllData(
        folderid!,
        searchText,
        pageNumber,
        pageSize,
      ),
    enabled: !!folderid && !!pageNumber && !!pageSize && isParentSelectAll,
  });

  const FileUploadMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: FormData) =>
      fileAttachmentApiService.uploadFile(payload),
  });

  const FileDeleteMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload) => fileAttachmentApiService.deleteData(payload),
  });

  return {
    FilesSelectAllQuery,
    ParentFilesSelectAllQuery,
    FileUploadMutation,
    FileDeleteMutation,
  };
};
